// Modules
import styled from 'styled-components'
// Application
import breakPoint from 'theme/breakpoints'

export const ContainerContent = styled.section`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    padding: 0 16px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${breakPoint.tablet} {
        padding: 0 112px 32px;
    }

    ${breakPoint.desktop} {
        padding: 0 143px 32px;
    }

    ${breakPoint.custom('1366px')} {
        padding: 0 224px 32px;
    }
`
